import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NovedadesPeriodo } from '../../../../models/novedadesPeriodo';
import { ConfigDataService } from '../../../../services/config-data.service';
import { CodigosNominaService } from '../../../../services/codigosNomina.service';
import { PersonalService } from '../../../../services/personal.service';
import {MyValidations} from '../../../../utils/my-validations';
import { formatDate } from '@angular/common';
import { MomentSetService } from '../../../../core/services/moment-set.service';

@Component({
  selector: 'app-novedades-periodo-detalle',
  templateUrl: './novedades-periodo-detalle.component.html',
  styleUrls: ['./novedades-periodo-detalle.component.css']
})
export class NovedadesPeriodoDetalleComponent implements OnInit, AfterViewInit {
    monedasList: any;
    codigosNominaList: any;
    unidadesList: any;

  constructor(private configDataSrv: ConfigDataService,
              private codigosNominaService: CodigosNominaService,
              private fb: FormBuilder, 
              private personalService: PersonalService,
              private momentService: MomentSetService) { }

  @Input() set novedadPeriodo(novedadRecibida: NovedadesPeriodo)
  {
    this.novedadPeriodoForm = novedadRecibida;
    this.setearForm(novedadRecibida);
  }

  @Input() set enabledForm(condition: boolean)
  {
    this.habilitarForm(condition);
  }

  @Input() MensajeError: string;
  @Input() verDetalle: boolean;
  @Input() disabledEditing: boolean;
  @Input() desdeAnterior: boolean;
  @Input() ingreso: any;
  @Input() anteriorRetroactividad: boolean;
  @Input() grupoLiq: any;
  @Input() novedadesInvalida: boolean;

  form: FormGroup;
  novedadPeriodoForm: NovedadesPeriodo;
  actualizarFormatoInputNumerico = false;
  submitted: boolean;
  NominaList: any
  tipoCarga: number;
  formHabilitado: boolean;
  MensajeRetro = "";

  ngOnInit(): void
  {
    this.tipoCarga = 0;
    
    this.configDataSrv.getDatosNominas()
      .subscribe(
        data => {
          this.monedasList=data["Monedas"];
          this.unidadesList=data["UnidadesMedidas"];
        },
        error => {
          console.log(error);
        });
    
    this.codigosNominaService.getAll().subscribe(
      codigos => 
      { 
        codigos.forEach((currentValue,index,arr) => {
          currentValue.desde = this.momentService.convertDateServer(currentValue.desde);
          currentValue.hasta = this.momentService.convertDateServer(currentValue.hasta);
        });
        
        this.NominaList = codigos;
        this.cargaConceptos();
      });
    
    this.configurarValidadores();
    this.setearForm(this.novedadPeriodoForm);
  }

  configurarValidadores(): void
  {
    this.form = this.fb.group({
      id: ['', Validators.required],
      personal: ['', Validators.required],
      desde: ['', Validators.required],
      hasta: ['', [Validators.required, MyValidations.fecHastaMenor]],
      codigoNomina: ['', Validators.required],
      motivo: [''],
      cantidad: [''],
      importe: [''],
      moneda: [''],
      unidadMedida: ['', Validators.required],
    });

  }

  get registerFormControl()
  {
    return this.form.controls;
  }

  setearForm(novedadPeriodo: NovedadesPeriodo)
  {
    if (this.form != undefined)
    {
      this.form.controls['id'].setValue(novedadPeriodo?.id);
      this.form.controls['desde'].setValue(new Date(novedadPeriodo?.desde));
      this.form.controls['hasta'].setValue(new Date(novedadPeriodo?.hasta));
      this.form.controls['personal'].setValue(novedadPeriodo?.personal);
      this.form.controls['cantidad'].setValue(novedadPeriodo?.cantidad);
      this.form.controls['motivo'].setValue(novedadPeriodo?.motivo);
      this.form.controls['unidadMedida'].setValue(novedadPeriodo?.unidadMedida);
      this.form.controls['moneda'].setValue(novedadPeriodo?.moneda);
      this.form.controls['codigoNomina'].setValue(novedadPeriodo?.codigoNomina);
      this.form.controls['importe'].setValue(novedadPeriodo?.importe);

      if (novedadPeriodo.id == 0)
      {
        this.habilitarForm(true);
      }
      else
      {
        this.habilitarForm(false);
      }
      this.chequeoRetro();
    }
  }

  habilitarForm(habilitado: boolean)
  {
    if (this.form != undefined)
    {
      if (habilitado)
      {
        this.form.enable();
      }
      else
      {
        this.form.disable();
      }
      this.formHabilitado = habilitado;
      this.form.controls['unidadMedida'].disable();
      this.getTipoCargaCodigoNomina(this.novedadPeriodoForm.codigoNomina);
    }
  }

  ngAfterViewInit()
  {
    if (this.form.controls['id'].value != "0")
    {
      this.form.controls['importe'].setValue(this.novedadPeriodoForm?.importe);
      this.actualizarFormatoInputNumerico = true;
    }
  }

  onChangeCodigoNomina(event)
  {
    this.getTipoCargaCodigoNomina(event.value);
    if (this.tipoCarga == 2) 
    {
      this.form.controls['importe'].setValue(0);
      this.form.controls['moneda'].setValue(1);
    } else if (this.tipoCarga == 1)
    {
      this.form.controls['cantidad'].setValue(0);
    } else if (this.tipoCarga == 4)
    {
      this.form.controls['importe'].setValue(0);
      this.form.controls['moneda'].setValue(1);
      this.form.controls['cantidad'].setValue(0);
    }
    let unidadMedida = this.codigosNominaList.find(c => c.id == event.value).um;
    this.form.controls['unidadMedida'].setValue(unidadMedida);
  }

  getTipoCargaCodigoNomina(nomina:number){
    this.tipoCarga = 0;
    if (nomina != null) {
      this.tipoCarga = this.codigosNominaList.find(m => m.id == nomina).tipoCarga;
    }
    if (this.tipoCarga == 2) 
    {
      this.setValidatorRequired('importe', null);
      this.setValidatorRequired('moneda', null);
      this.setValidatorRequired('cantidad', Validators.required);
    } else if (this.tipoCarga == 1)
    {
      this.setValidatorRequired('importe', Validators.required);
      this.setValidatorRequired('moneda', Validators.required);
      this.setValidatorRequired('cantidad', null);
    } else if (this.tipoCarga == 3)
    {
      this.setValidatorRequired('importe', Validators.required);
      this.setValidatorRequired('cantidad', Validators.required);
      this.setValidatorRequired('moneda', Validators.required);
    } else
    {
      this.setValidatorRequired('importe', null);
      this.setValidatorRequired('moneda', null);
      this.setValidatorRequired('cantidad', null);
    }
  }

  setValidatorRequired(campo, requerido) {
    this.form.controls[campo].setValidators(requerido);
    this.form.controls[campo].updateValueAndValidity();
  }

  cargaConceptos()
  {
    //Carga los conceptos validos
    let desde = this.form.get("desde").value.toDateString();
    let hasta = this.form.get("hasta").value.toDateString();
    let concepto = this.form.get("codigoNomina").value;

    this.codigosNominaList = this.NominaList && this.NominaList.filter(items => items.novedadesPeriodo == true &&
                                                                                Date.parse(items.desde) <= Date.parse(hasta) &&
                                                                                Date.parse(items.hasta) >= Date.parse(desde)) ;
    
    let index = this.codigosNominaList.findIndex(x => x.id == concepto)
    if (index == -1)
    {
      //No existe en la nueva lista, lo limpio
      this.form.controls['codigoNomina'].setValue(null);
    }
  }

  onChangeFechas()
  {
    this.cargaConceptos();
    this.chequeoRetro();
  }

  chequeoRetro()
  {
    this.MensajeRetro = "";
    let desde = this.form.get("desde").value.toDateString();
    let hasta = this.form.get("hasta").value.toDateString();
    
    this.personalService.ChequeoRetroactividad(this.novedadPeriodoForm.personal, 'NovedadesPeriodo', desde, hasta, true).subscribe(
      data =>
      {
        let resul = data;
        if (resul.haceRetro)
        {
          let fecha = formatDate(resul.fechaRetro, 'dd-MM-yyyy', 'en-US');
          this.MensajeRetro = "Esta acción generará Retro a partir del " + fecha.toString();
        }
      }
    );
  }
}

